<template>
  <div class="main">
    <topImg :title="banner.title" :desc="''" :img="banner.thumb"></topImg>
    <!-- 顶部模块分类 -->
    <div class="tab">
      <template v-for="item of tabList">
        <a
          :key="item.id"
          class="list"
          :class="[item.id === tabActive ? 'active' : '']"
          @click.prevent="selectTab(item)"
          href="javascript:;"
          v-if="judgeTypeShow(item.type)"
        >
          {{ item.title }}
        </a>
      </template>
    </div>
    <!-- 方案介绍 -->
    <div id="module1" class="module"></div>
    <div class="introduce" v-if="introduce">
      <img :src="introduce.thumb" alt="" />
      <div class="right">
        <div class="title">{{ introduce.title }}</div>
        <div class="desc">
          {{ introduce.desc }}
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div id="module2" class="module"></div>
    <div class="advantage" v-if="advantage">
      <div class="headline">方案优势</div>
      <div class="content">
        <div class="left">
          <div
            class="list"
            v-for="(item, index) of advantage.list"
            :key="index"
          >
            <img
              :src="
                'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/6' +
                (index + 1) +
                '.png'
              "
              alt=""
            />
            <span class="title">{{ item.title }}</span>
            <span class="desc">{{ item.desc }}</span>
          </div>
        </div>
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/gaozhixiao_plan/gongcheng/youshi.png" alt="" />
      </div>
    </div>
    <!-- 方案构成 -->
    <div id="module3" class="module"></div>
    <div class="constitute" v-if="constitute">
      <div class="headline">方案构成</div>
      <div class="content">
        <img src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/gaozhixiao_plan/gongcheng/goucheng.png" alt="" />
        <div class="right">
          <div class="list" v-for="item of constitute.list" :key="item.title">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <!-- <div class="scene" id="module4" v-if="scene">
      <div class="headline">应用场景</div>
      <div class="content">
        <div class="list" v-for="item of scene" :key="item.alt">
          <img :src="item.url" class="backgroundImg" alt="" />
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/common/news.png"
            class="num"
            alt=""
          />
          <div class="title">{{ item.alt }}</div>
        </div>
      </div>
    </div> -->
    <!-- 课程资源 -->
    <div id="module5" class="module"></div>
    <div class="resource" v-if="resource.res_list">
      <div>
        <div class="headline">课程资源</div>
        <div class="content">
          <div class="left">
            <div v-html="resource.res_list"></div>
            <!-- <div class="list" v-for="item of 10" :key="item">
            · 木构架古建筑构件（斗拱）BIM-VR虚拟仿真课件资源R虚拟仿真课件资源
          </div> -->
          </div>
          <img class="right" src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/gaozhixiao_plan/gongcheng/ziyuan.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 相关案例 -->
    <div id="module6" class="module"></div>
    <div class="case" v-if="caseList">
      <div class="headline" ref="test">相关案例</div>
      <div class="content">
        <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="mySwiper"
          @someSwiperEvent="callback"
        >
          <swiper-slide class="slide" v-for="item of caseList" :key="item.alt">
            <div>
              <img v-lazy="item.url" :key="item.url" />
              <div class="title">{{ item.alt }}</div>
            </div>
          </swiper-slide>
        </swiper>
        <!-- <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/58.png"
          class="customPrev"
          alt=""
          @click="swiperPrev"
        />
        <img
          src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/59.png"
          class="customNext"
          alt=""
          @click="swiperNext"
        /> -->
        <div class="more" @click="go('customerStories')">
          <span>查看更多案例</span>
          <img
            src="https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/60.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 侧边栏 -->
    <!-- <div class="sidebar" v-show="showSidebar">
      <template v-for="item of tabList">
        <a
          :key="item.id"
          class="list"
          :class="[item.id === tabActive ? 'active' : '']"
          @click="selectTab(item)"
          :href="'#module' + item.id"
          v-if="judgeTypeShow(item.type)"
        >
          {{ item.title }}
        </a>
      </template>
    </div> -->
  </div>
</template>

<script>
import topImg from '@/component/topImg';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import { planDetail } from '@/services/api';

export default {
  components: {
    topImg,
    swiper,
    swiperSlide
  },
  data() {
    return {
      tabList: [
        {
          id: 1,
          title: '方案介绍',
          type: 'introduce'
        },
        {
          id: 2,
          title: '方案优势',
          type: 'advantage'
        },
        {
          id: 3,
          title: '方案构成',
          type: 'constitute'
        },
        {
          id: 4,
          title: '应用场景',
          type: 'scene'
        },
        {
          id: 5,
          title: '课程资源',
          type: 'resource'
        },
        {
          id: 6,
          title: '相关案例',
          type: 'caseList'
        }
      ],
      tabActive: '3',
      swiperOption: {
        loop: true, // true循环轮播;false不循环轮播
        autoplay: false, // true自动播放;false不自动播放
        pagination: {
          el: '.swiper-pagination' // 分页器
        },
        init: false,
        slidesPerView: 3
        // 其他的所有的参数同 swiper 官方 api 参数
      },
      showSidebar: false,
      banner: {
        title: '',
        thumb: ''
      },
      introduce: {},
      advantage: {},
      constitute: {
        list: [],
        thumb: ''
      },
      scene: [],
      resource: {
        res_list: '',
        thumb: ''
      },
      caseList: []
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getData();
    this.swiper.slideTo(3, 1000, false);
    window.onscroll = () => {
      this.scollSelectTab();
    };
  },
  methods: {
    getData() {
      planDetail({
        id: this.id
      }).then(res => {
        console.log(res);
        this.banner = res.data.banner;
        this.introduce = res.data.jieshao;
        this.advantage = res.data.youshi;
        this.constitute = res.data.goucheng;
        this.scene = res.data.changjing;
        this.resource = res.data.course_res;
        this.caseList = res.data.anli;

        this.swiperOption.slidesPerView = this.caseList
          ? Math.min(this.caseList.length, 3)
          : 1;
        this.$refs.mySwiper.mountInstance();
      });
    },
    judgeTypeShow(type) {
      if (type === 'resource') {
        return !!(this.resource && this.resource.res_list);
      }
      if (type === 'constitute') {
        return !!(this.constitute && this.constitute.list && this.constitute.list.length);
      }
      return !!this[type];
    },
    // imgUrl(num) {
    //   return (
    //     'https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/plan/' +
    //     num +
    //     '.png'
    //   );
    // },
    selectTab(item) {
      this.tabActive = item.id;
      // JS精准滚动定位，兼容移动端地址栏伸缩
      const targetEl = document.getElementById('module' + item.id);
      if (targetEl) {
        const rect = targetEl.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
        const absoluteTop = rect.top + scrollTop;
        window.scrollTo({
          top: absoluteTop,
          behavior: 'smooth'
        });
      }
    },
    callback(e) {
      console.log(e);
    },
    swiperPrev() {
      this.swiper.slidePrev();
    },
    swiperNext() {
      this.swiper.slideNext();
    },
    scollSelectTab() {
      // let showSidebar = false;

      // // 滚动条高度+视窗高度 = 可见区域底部高度
      // var visibleBottom =
      //   window.scrollY + document.documentElement.clientHeight;
      // // 可见区域顶部高度
      // var visibleTop = window.scrollY;

      // this.tabList.forEach(item => {
      //   let itemDom = document.getElementById('module' + item.id);
      //   if (!itemDom) return;
      //   var centerY = itemDom.offsetTop + itemDom.offsetHeight * 0.8;
      //   var show = centerY > visibleTop && centerY < visibleBottom;
      //   if (show) {
      //     this.selectTab(item);
      //     showSidebar = true;
      //   }
      // });

      // 为了保证兼容性，这里取两个值，哪个有值取哪一个
      // scrollTop就是触发滚轮事件时滚轮的高度
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      console.log('滚动距离' + scrollTop);
      // if (scrollTop < 500) {
      //   showSidebar = false;
      // }

      // this.showSidebar = showSidebar;
    },
    go(name) {
      this.$router.push({
        name
      });
    }
  },
  watch: {
    $route(to, from) {
      if (from.name === to.name) {
        this.id = this.$route.query.id;
        this.getData();
        this.banner = {
          title: '',
          thumb: ''
        };
        this.introduce = {};
        this.advantage = {};
        this.constitute = {
          list: [],
          thumb: ''
        };
        this.scene = [];
        this.resource = {
          res_list: '',
          thumb: ''
        };
        this.caseList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  background: #fff;
  width: 100%;
  .module{
    position: relative;
    top: -80px;
    left: 0;
  }
  .tab {
    width: 1200px;
    height: 70px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .list {
      height: 100%;
      line-height: 70px;
      font-weight: 1;
      color: #202122;
      font-size: 18px;
      cursor: pointer;
    }
    .active {
      color: #f27529;
      position: relative;
    }
    .active::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -30px;
      width: 60px;
      height: 3px;
      background: #f27529;
      border-radius: 2px;
    }
  }
  .introduce {
    width: 1200px;
    height: 568px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > img {
      width: 408px;
      height: 454px;
      align-self: start;
      margin-top: 30px;
    }
    > .right {
      width: 675px;
      .title {
        font-size: 32px;
        font-weight: 600;
        color: #000000;
        line-height: 45px;
      }
      .desc {
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        line-height: 38px;
        margin-top: 22px;
      }
    }
  }
  .advantage {
    padding-top: 62px;
    // padding-bottom: 119px;
    width: 100%;
    overflow: hidden;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_shouqian.png);
    background-size: 100% 100%;
    .headline {
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
    }
    .content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      min-height: 470px;
      align-items: center;
      justify-content: space-between;
      margin-top: 119px;
      .left {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        width: 800px;
        height: 100%;
        padding-bottom: 119px;
        padding-left: 88px;
        margin-top: -10px;
        min-height: 470px;
        .list {
          position: relative;
          display: flex;
          // align-items: center;
          height: 0px;
          margin: 38px 0;
          img {
            width: 25px;
            height: 25px;
            margin-right: 17px;
          }
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #f27529;
            line-height: 25px;
          }
          .desc {
            position: absolute;
            top: 35px;
            left: 42px;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
          }
        }
      }
      > img {
        width: 499px;
        height: 457px;
        margin-top: 10px;
      }
    }
  }
  .constitute {
    width: 1200px;
    height: 894px;
    margin: 0 auto;
    .headline {
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      padding: 70px 0 90px 0;
    }
    .content {
      display: flex;
      > img {
        width: 731px;
        height: 557px;
        margin-right: 97px;
        display: block;
      }
      .right {
        height: 500px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .list {
          margin: 20px 0;
          .title {
            font-size: 16px;
            font-weight: 500;
            color: #f27529;
            line-height: 22px;
          }
          .desc {
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 20px;
            margin-top: 12px;
          }
        }
      }
    }
  }
  .scene {
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_shouqian.png);
    background-size: 100% 100%;
    padding-bottom: 50px;
    .headline {
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      padding: 70px 0 68px 0;
    }
    .content {
      display: flex;
      justify-content: center;
      .list {
        width: 25%;
        padding-bottom: 18.75%;
        position: relative;
        .num {
          width: 68px;
          height: 39px;
          position: absolute;
          top: 30px;
          left: 35px;
        }
        .title {
          font-size: 22px;
          font-weight: 500;
          color: #ffffff;
          line-height: 30px;
          position: absolute;
          left: 35px;
          top: 59px;
        }
        .title::after {
          content: "";
          position: absolute;
          bottom: -12px;
          left: 0;
          width: 30px;
          height: 3px;
          background: #fff;
          border-radius: 2px;
        }
        .backgroundImg {
          width: 100%;
          height: 100%;
          position: absolute;
        }
      }
    }
  }
  .resource {
    width: 100%;
    background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_shouqian.png);
    background-size: 100% 100%;
    > div {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 158px;
      .headline {
        width: 100%;
        text-align: center;
        font-size: 28px;
        font-weight: 600;
        color: #000000;
        line-height: 40px;
        padding: 70px 0 101px 0;
      }
      .content {
        display: flex;
        justify-content: center;
        .left {
          width: 353px;
          padding-right: 10px;
          box-sizing: border-box;
          display: flex;
          // align-items: center;
          justify-content: center;
          flex-direction: column;
          // .list {
          //   font-size: 14px;
          //   font-weight: 400;
          //   color: #000000;
          //   line-height: 20px;
          //   margin-top: 14px;
          // }
        }
        .right {
          width: 600px;
          height: 430px;
        }
      }
    }
  }
  .case {
    width: 100%;
    height: 740px;
    padding-bottom: 62px;
    .headline {
      width: 100%;
      text-align: center;
      font-size: 28px;
      font-weight: 600;
      color: #000000;
      line-height: 40px;
      padding: 70px 0 70px 0;
    }
    .content {
      width: 1260px;
      margin: 0 auto;
      position: relative;
      .customPrev,
      .customNext {
        position: absolute;
        left: -100px;
        top: 130px;
        width: 75px;
        height: 75px;
        cursor: pointer;
      }
      .customNext {
        right: -100px;
        left: auto;
      }
      .mySwiper {
        height: 420px;
        overflow: inherit;
      }
      .slide {
        padding: 0 15px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        > div {
          width: 380px;
          height: 420px;
          text-align: center;
          background: #ffffff;
          box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.12);
          border-radius: 19px;
          overflow: hidden;
          img {
            width: 100%;
            height: 324px;
            object-fit: cover;
            display: block;
          }
          .title {
            width: 100%;
            height: 96px;
            text-align: center;
            line-height: 96px;
            font-size: 26px;
          }
        }
      }
      .more {
        margin-top: 62px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        span {
          font-size: 14px;
          font-weight: 500;
          color: #444a62;
          line-height: 17px;
        }
        img {
          width: 14px;
          height: 12px;
          margin-left: 6px;
          margin-top: 2px;
        }
      }
    }
  }
  .sidebar {
    position: fixed;
    top: 280px;
    left: 104px;
    z-index: 200;
    .list {
      font-size: 16px;
      font-weight: 400;
      color: #7e90a8;
      line-height: 22px;
      padding-left: 24px;
      margin-bottom: 50px;
      position: relative;
      cursor: pointer;
      display: block;
    }
    .list::after {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      width: 9px;
      height: 9px;
      background: #ced5df;
      margin-top: -5px;
    }
    .active {
      color: #f1703f;
    }
    .active::after {
      background: #f1703f;
    }
  }
}
@media (max-width: 1000px) {
  .module{
    top: -0px;
  }
  .main {
    .tab {
      width: 100%;
      height: auto;
      padding: 16px 8px;
      box-sizing: border-box;
      flex-wrap: no-wrap;
      justify-content: center;
      .list {
        font-size: 26px;
        line-height: 60px;
        margin-right: 30px;
      }
      .list:last-of-type {
        margin-right: 0;
      }
    }
    .introduce {
      width: 100%;
      height: auto;
      padding: 60px 48px;
      box-sizing: border-box;
      flex-direction: column;
      > img {
        width: 100%;
        height: auto;
        align-self: auto;
        margin-top: 0;
      }
      > .right {
        width: 100%;
        margin-top: 40px;
        .title {
          font-size: 36px;
          line-height: 50px;
        }
        .desc {
          font-size: 26px;
          line-height: 44px;
          margin-top: 20px;
        }
      }
    }
    .advantage {
      padding-top: 60px;
      .headline {
        font-size: 36px;
      }
      .content {
        width: 100%;
        padding: 40px 48px 60px;
        box-sizing: border-box;
        flex-direction: column;
        margin-top: 40px;
        .left {
          width: 100%;
          padding-left: 0;
          padding-bottom: 40px;
          min-height: auto;
          .list {
            height: auto;
            margin: 30px 0;
            .title {
              font-size: 28px;
              line-height: 40px;
            }
            .desc {
              position: static;
              margin-top: 10px;
              font-size: 24px;
              line-height: 36px;
            }
          }
        }
        > img {
          width: 100%;
          height: auto;
          margin-top: 0;
        }
      }
    }
    .constitute {
      width: 100%;
      height: auto;
      padding: 0 48px;
      box-sizing: border-box;
      .headline {
        font-size: 36px;
        padding: 60px 0 40px 0;
      }
      .content {
        flex-direction: column;
        > img {
          width: 100%;
          height: auto;
          margin-right: 0;
          margin-bottom: 30px;
        }
        .right {
          height: auto;
          .list {
            .title {
              font-size: 28px;
            }
            .desc {
              font-size: 24px;
              line-height: 36px;
            }
          }
        }
      }
    }
    .resource {
      > div {
        width: 100%;
        padding: 0 48px 80px;
        box-sizing: border-box;
        .headline {
          font-size: 36px;
          padding: 60px 0 60px 0;
        }
        .content {
          flex-direction: column;
          .left {
            width: 100%;
            font-size: 26px;
            line-height: 44px;
          }
          .right {
            width: 100%;
            height: auto;
            margin-top: 30px;
          }
        }
      }
    }
    .case {
      height: auto;
      padding-bottom: 40px;
      .headline {
        font-size: 36px;
        padding: 60px 0 40px 0;
      }
      .content {
        width: 100%;
        padding: 0 48px;
        box-sizing: border-box;
        .mySwiper {
          height: auto;
        }
        .slide {
          padding: 0 10px;
          width: 100%;
          > div {
            width: 100%;
            height: auto;
            img {
              height: 280px;
            }
            .title {
              height: 80px;
              line-height: 80px;
              font-size: 28px;
              // 省略号
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .more {
          margin-top: 40px;
          span {
            font-size: 28px;
          }
        }
      }
    }
  }
}
</style>
